// partner-network.routes.ts
import { EnvironmentProviders, Provider } from '@angular/core';
import { MAT_CARD_CONFIG, MatCardConfig } from '@angular/material/card';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldDefaultOptions } from '@angular/material/form-field';
import { Routes } from '@angular/router';

export const PARTNER_NETWORK_FORM_FIELD: MatFormFieldDefaultOptions = {
    appearance: 'outline',
    color: 'primary',
    floatLabel: 'always'
};

export const PARTNER_NETWORK_CARD: MatCardConfig = {
    appearance: 'outlined'
};

export const PARTNER_NETWORK_PROVIDERS: (Provider | EnvironmentProviders)[] = [
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: PARTNER_NETWORK_FORM_FIELD },
    { provide: MAT_CARD_CONFIG, useValue: PARTNER_NETWORK_CARD }
];

export const PARTNER_NETWORK_ROUTES: Routes = [
    {
        path: 'candidate',
        loadComponent: () =>
            import('./subcontractor/grid/component/subcontractor.component').then((m) => m.SubcontractorComponent),
        title: 'Candidates'
    },
    {
        path: 'candidate/:userId',
        loadComponent: () =>
            import('src/app/partner-network/subcontractor/subcontractor-details/subcontractor-details.component').then(
                (m) => m.SubcontractorDetailsComponent
            ),
        title: 'Candidate'
    },
    {
        path: 'job',
        loadComponent: () =>
            import('./job-search/grid/component/job-search.component').then((m) => m.JobSearchComponent),
        title: 'Jobs'
    },
    {
        path: 'facility',
        loadComponent: () =>
            import('src/app/partner-network/facility-search/grid/component/facility-search.component').then(
                (m) => m.FacilitySearchComponent
            ),
        title: 'Facilities'
    },
    {
        path: 'margin',
        loadComponent: () =>
            import('./margin-search/grid/component/margin-search.component').then((m) => m.MarginSearchComponent),
        data: { cacheParent: 'all' },
        title: 'Margins'
    },
    {
        path: 'facility-details/:facilityId',
        loadComponent: () =>
            import('./facility-search/grid/component/facility-details/facility-details.component').then(
                (m) => m.FacilityDetailsComponent
            ),
        title: 'Facility'
    },
    {
        path: 'system-details/:id',
        loadComponent: () =>
            import('./system-details-container/system-details-container.component').then(
                (m) => m.PartnerNetworkSystemDetailsContainerComponent
            ),
        title: 'System Id'
    },
    {
        path: 'state/:jobId/:tab',
        loadComponent: () =>
            import('../shared/components/job-state-details/job-state-details.component').then(
                (m) => m.JobStateDetailsComponent
            ),
        data: { cacheParent: 'all' },
        title: 'Job Id'
    },
    {
        path: 'offers',
        loadComponent: () => import('./offers/offers.component').then((m) => m.OffersComponent),
        title: 'Offers'
    },
    {
        path: 'offers/new',
        loadComponent: () => import('./offer-create/offer-create-component').then((m) => m.OfferCreateComponent),
        data: { cacheParent: 'partnernetwork/offers' },
        title: 'Add Offer'
    },
    {
        path: 'offers/:id',
        loadComponent: () => import('./offer-details/offer-details.component').then((m) => m.OfferDetailsComponent),
        data: { cacheParent: 'partnernetwork/offers' },
        title: 'Offer Id'
    },
    {
        path: 'live-nurses',
        loadComponent: () =>
            import('src/app/partner-network/live-nurses/grid/components/live-nurses.component').then(
                (m) => m.LiveNursesComponent
            ),
        title: 'Live Nurses'
    },
    {
        path: 'auto-assign',
        loadComponent: () =>
            import('src/app/partner-network/auto-assign/auto-assign.component').then((m) => m.AutoAssignComponent),
        title: 'Auto Assign'
    },
    {
        path: '**',
        loadComponent: () =>
            import('./subcontractor/grid/component/subcontractor.component').then((m) => m.SubcontractorComponent)
    }
];
